module.exports = __webpack_public_path__ + "static/media/bed22x.51914035.png";